import Component from '../abstracts/Component';
import { doAjax } from '../utils/ajaxUtil';

export default class WishlistLogic extends Component {

  get CLASSES() {
    return {
      iconWishlistEmpty: "icon-wishlist-empty",
      iconWishlistFull: "icon-wishlist-full",
      greyColor: "--txt-grey-mid",
    };
  }

  constructor() {
    super();
  }

  async addToWishlist(url,productCode) {
    const response = await fetch(url+"?code="+productCode);
    if (response.ok) {
      return response;
    }
    return null;
  }

  async removeFromWishlist(url, productCode) {
    const response = await fetch(url+productCode, {
      method: "POST",
      headers: {
        'Content-Type': 'application/json'
      }
    });
    if (response.ok) {
      return response;
    }
    return null;
  }

  wishlistCheckAjax(productCode) {
    return new Promise( (resolve, reject) => {
      let data = {};
      data[productCode] = productCode;
      const contextPath = document.getElementsByTagName('HTML')[0].getAttribute("data-context");
      $.ajax({
        url: contextPath + "/action/ajax/wishlist-check-product",
        data: {
          code: productCode
        },
        success: function (result) {
          resolve(result);
        }
      });
    });
  }

  updateHeaderWishlistIcon(headerIcon, isEmpty=true) {
    if(isEmpty) {
      headerIcon.classList.remove(this.CLASSES.iconWishlistFull);
      headerIcon.classList.add(this.CLASSES.iconWishlistEmpty);
    } else {
      headerIcon.classList.add(this.CLASSES.iconWishlistFull);
      headerIcon.classList.remove(this.CLASSES.iconWishlistEmpty);
    }
  }

  updateWishlistIcon(icon, isEmpty=true) {
    isEmpty ? icon.classList.add(this.CLASSES.greyColor) : icon.classList.remove(this.CLASSES.greyColor)
  }

  updatePDPButton(button, isInWishlist=true) {
    if (isInWishlist) {
      const btnMessage = button.querySelector(".custom-button__message");
      btnMessage ? btnMessage.innerHTML = button.dataset.confirmMessage : '';
      button.dataset.wishlistBtn = true;
    } else {
      const btnMessage = button.querySelector(".custom-button__message");
      btnMessage ? btnMessage.innerHTML = button.dataset.addMessage : '';
      button.dataset.wishlistBtn = false;
    }
  }

  render() {}
}
